module.exports = {"Operate12":{"daobanList":[{"title":"1:您是是否办理建设项目环境影响报告表审批？","values":[{"name":"是的","xuanzhong":1,"cailiaoList":[{"name":"1、建设单位申请报批项目环评文件的申请书","state":"必要"},{"name":"2、建设项目环境影响报告表","state":"必要"},{"name":"3、建设项目环境影响报告表（公开版）","state":"必要"}]},{"name":"不是","xuanzhong":0,"cailiaoList":[{}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/sdo-12.json
// module id = 1269
// module chunks = 0